import { render, staticRenderFns } from "./TicketBadge.pug?vue&type=template&id=5ad74c84&scoped=true&lang=pug&"
import script from "./TicketBadge.vue?vue&type=script&lang=js&"
export * from "./TicketBadge.vue?vue&type=script&lang=js&"
import style0 from "./TicketBadge.scss?vue&type=style&index=0&id=5ad74c84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad74c84",
  null
  
)

export default component.exports